import { Link } from 'react-router-dom';

/**
 * État « pas de soirée » côté invité.
 * Plus une impasse : propose toujours une sortie navigable (Accueil / changer
 * de bar) et, quand c'est pertinent (soirée pas encore lancée, erreur de
 * chargement), un bouton Réessayer qui relance le chargement.
 */
export default function EmptyEvent({ message, onRetry, showHome = true }) {
  return (
    <div className="container-mobile flex min-h-dvh flex-col items-center justify-center text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-white/5 text-3xl">
        🎧
      </div>
      <h1 className="text-xl font-bold tracking-tight">Aucune soirée active</h1>
      <p className="mt-2 max-w-xs text-sm text-white/60">
        {message ??
          "Le DJ n'a pas encore lancé la soirée, ou ce QR code n'est plus valide. Réessaie dans un instant."}
      </p>

      <div className="mt-6 flex w-full max-w-xs flex-col gap-2">
        {onRetry ? (
          <button type="button" className="btn-primary w-full" onClick={onRetry}>
            Réessayer
          </button>
        ) : null}
        {showHome ? (
          <Link to="/" className="btn-secondary w-full text-center">
            Changer de bar
          </Link>
        ) : null}
      </div>
    </div>
  );
}
